import angular from "angular";

class UnauthorizedConfig {
    static $inject = ["$stateProvider"];

    constructor(private $stateProvider: ng.ui.IStateProvider) {
        this.init();
    }

    private init() {
        this.$stateProvider.state("unauthorized", {
            url: "^/unauthorized",
            template: require("./unauthorized.html")
        });
    }
}

angular.module("topline.modules").config(UnauthorizedConfig);
